import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import FileGroupingExportFileSpecSearchCriteria from '../Models/Queries/FileGroupingExportFileSpecSearchCriteria';
import { Data, List, NotifyUtils } from '@singularsystems/neo-core';
import StaticExportFileSpecLookup from '../../FileSpecConfigurations/Models/Lookups/StaticExportFileSpecLookup';
import FileGroupingExportFileSpecLookup from '../Models/Lookups/FileGroupingExportFileSpecLookup';
import UpdateStaticFileGroupingExportFileSpecCommand from '../Models/Commands/UpdateStaticFileGroupingExportFileSpecCommand';
import { TextConstants } from '../../../Common/TextConstants';
import { NotificationDuration } from '../../../App/Models/Enums/NotificationDuration';
import CreateStaticFileGroupingExportFileSpecCommand from '../Models/Commands/CreateStaticFileGroupingExportFileSpecCommand';
import RawGenericExportMappingComponentVM from '../../RawGenericExportMappings/Components/RawGenericExportMappingComponentVM';
import { reaction } from 'mobx';


export default class FileGroupingFileSpecExportConfigurationComponentVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public staticExportFileSpecApiClient = AppService.get(Types.ApiClients.StaticExportFileSpecApiClient),
        public fileGroupingExportFileSpecApiClient = AppService.get(Types.ApiClients.FileGroupingExportFileSpecApiClient),
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)) {

        super(taskRunner);
        this.makeObservable();
    }

    public showFileGroupingExportFileSpecComponent: boolean = false;
    public showManageFileGroupingExportFileSpecComponent: boolean = false;
    public showRawGenericExportMappingComponent: boolean = false;
    public staticExportFileSpecId: number = 0;

    public fileGroupingExportFileSpecSearchCriteria = new FileGroupingExportFileSpecSearchCriteria();
    public exportFileSpecDropdownList = new List(StaticExportFileSpecLookup);

    public managedFileGroupingExportFileSpec = new FileGroupingExportFileSpecLookup();
    public isFieldReadOnlyInd: boolean = false;

    public rawGenericExportMappingComponentVM = new RawGenericExportMappingComponentVM()

    public pageManager = new Data.PageManager(this.fileGroupingExportFileSpecSearchCriteria, FileGroupingExportFileSpecLookup,
        this.fileGroupingExportFileSpecApiClient.getFileGroupingExportFileSpecs, {
            pageSize: 10,
            sortAscending: false,
            fetchInitial: false,
            initialTaskRunner: this.taskRunner
        });

    public async initialise() {
        reaction(() => this.fileGroupingExportFileSpecSearchCriteria.searchCriteria, () => this.pageManager.refreshData(), {fireImmediately: false, delay: 650 });
    }

    public async addNewFileGroupingExportFileSpec() {
        this.showManageFileGroupingExportFileSpecComponent = true;
        this.managedFileGroupingExportFileSpec = new FileGroupingExportFileSpecLookup();
    }

    public async editFileGroupingExportFileSpec(fileGroupingExportFileSpec: FileGroupingExportFileSpecLookup) {
        this.showManageFileGroupingExportFileSpecComponent = true;
        this.managedFileGroupingExportFileSpec.mapFrom(fileGroupingExportFileSpec).toJSObject();
        this.isFieldReadOnlyInd = true;
    }

    public async viewRawGenericExportMappings(staticServiceProviderFileGroupingId: number, staticExportFileSpecId: number) {
        this.showRawGenericExportMappingComponent = true;
        this.rawGenericExportMappingComponentVM.rawGenericExportMappingSearchCriteria.staticServiceProviderFileGroupingId = staticServiceProviderFileGroupingId;
        this.rawGenericExportMappingComponentVM.rawGenericExportMappingSearchCriteria.staticExportFileSpecId = staticExportFileSpecId;
        await this.rawGenericExportMappingComponentVM.initialise();
    }

    public async clearSearch() {
        this.fileGroupingExportFileSpecSearchCriteria.meta.searchCriteria.value = "";
        await this.pageManager.refreshData();
    }

    public backToFileConfigurations() {
        this.showFileGroupingExportFileSpecComponent = false;
        this.fileGroupingExportFileSpecSearchCriteria = new FileGroupingExportFileSpecSearchCriteria();
    }

    public cancel() {
        this.showManageFileGroupingExportFileSpecComponent = false;
        this.isFieldReadOnlyInd = false;
        this.managedFileGroupingExportFileSpec = new FileGroupingExportFileSpecLookup();
    }

    public cancelRawGenericMapping() {
        this.showRawGenericExportMappingComponent = false;
    }

    public async savebrokerExportConfiguration() {
        this.taskRunner.run(async () => {
            var response = this.managedFileGroupingExportFileSpec.staticServiceProviderFileGroupingExportFileSpecId > 0
            ? await this.fileGroupingExportFileSpecApiClient.updateFileGroupingExportFileSpec((this.mapBrokerExportConfigToUpdateCommand()!.toJSObject()))
            : await this.fileGroupingExportFileSpecApiClient.addNewFileGroupingExportFileSpec((this.mapBrokerExportConfigToCreateCommand()!.toJSObject()));

            if (response.data.success) {
                await this.pageManager.refreshData();
                NotifyUtils.addSuccess(TextConstants.Titles.Success, "Stockbroker file spec has been successfully saved.", NotificationDuration.Standard);
            }
            else {
                NotifyUtils.add(TextConstants.Titles.Error, response.data.error, "danger" as any, NotificationDuration.Long);
            }
            this.managedFileGroupingExportFileSpec = new FileGroupingExportFileSpecLookup();
            this.showManageFileGroupingExportFileSpecComponent = false;
            this.isFieldReadOnlyInd = false;
        })
    }

    private mapBrokerExportConfigToCreateCommand() {
        var command = new CreateStaticFileGroupingExportFileSpecCommand().mapFrom(this.managedFileGroupingExportFileSpec);
        return command;
    }

    private mapBrokerExportConfigToUpdateCommand() {
        var command = new UpdateStaticFileGroupingExportFileSpecCommand().mapFrom(this.managedFileGroupingExportFileSpec);
        return command;
    }
}